import { useEffect, useState, type ReactElement } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { ConfirmBox } from '@corratech/pylot-ui'
import {
    acceptImageConsentModal,
    closeImageConsentModal,
    subscribeImageConsentAlert
} from './imageConsentAlert'
import s from './ImageConsentModal.module.scss'

export const ImageConsentModal = (): ReactElement => {
    const { t } = useTranslation('common')
    // Siempre false en SSR/hidratación; abrir solo en client (effect / openImageConsentModal).
    const [show, setShow] = useState(false)

    useEffect(() => subscribeImageConsentAlert(setShow), [])

    const handleClose = (): void => {
        closeImageConsentModal()
    }

    const handleAccept = (): void => {
        acceptImageConsentModal()
    }

    return (
        <ConfirmBox
            show={show}
            closeConfirm={handleClose}
            handleAction={handleAccept}
            className={s.modal}
            icon="warning"
            title={t('search|Image consent title')}
            confirmString={t('search|Image consent accept')}
            cancelString={t('search|Image consent cancel')}
            variant="cart"
        >
            <div className={s.body}>
                <p>{t('search|Image consent body')}</p>
            </div>
        </ConfirmBox>
    )
}
